<template>
    <span v-show="count">
        {{ $tc('text', getText, { count, total }) }}
    </span>
</template>

<script>
export default {
    name: 'PaginationCountSelection',
    props: {
        count: {
            type: Number,
            required: true,
            default: 0,
        },
        total: {
            type: Number,
            required: true,
        },
    },
    computed: {
        getText() {
            return this.count < 2 ? 1 : 2
        },
    },
    i18n: {
        messages: {
            'en-US': {
                text: '{count} selected item out of {total}. | {count} selected items out of {total}.',
            },
            'es-ES': {
                text: '{count} artículo seleccionado de {total}. | {count} artículos seleccionados de {total}.',
            },
            'pt-BR': {
                text: '{count} item selecionado de {total}. | {count} itens selecionados de {total}.',
            },
        },
    },
}
</script>
